import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  size?: number;
  showWordmark?: boolean;
}

/** Shared brand mark — used in both the app Layout header and the MarketingShell. */
export default function Logo({ size = 32, showWordmark = true }: Props) {
  const { t } = useTranslation();
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <svg width={size} height={size} viewBox="0 0 32 32" style={{ flexShrink: 0 }}>
        <circle cx="16" cy="16" r="15" fill="var(--color-accent)" />
        <circle cx="16" cy="16" r="9.5" fill="color-mix(in srgb, var(--color-accent) 55%, black)" />
        <path d="M10.5 19.5 L16 13.5 L21.5 19.5" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {showWordmark && (
        <span style={{
          fontFamily: "var(--font-display)", fontSize: "1.25rem", fontWeight: 700,
          letterSpacing: "0.02em", color: "var(--color-text)",
        }}>
          {t("nav.appName")}
        </span>
      )}
    </span>
  );
}
